/* NG stock-aware pre-order handling (Irony Home draft, Oct 12 2026).
   For [data-ng-stock] boxes on pre-order templates: when the selected variant has units on hand,
   show "In stock", drop the pre-order selling plan from the form and show "Add to Cart".
   Zero-stock variants keep the pre-order message and the Timesact pre-order flow. */
(function () {
  /* Apps (Timesact) set button text directly and wipe the theme's [data-add-to-cart-text] span;
     the theme's variant-change handler then throws and never updates the variant id. Restore it. */
  function fixLabels() {
    document.querySelectorAll('button[data-add-to-cart]').forEach(function (b) {
      if (b.querySelector('[data-add-to-cart-text]')) return;
      var s = document.createElement('span'); s.setAttribute('data-add-to-cart-text', '');
      s.textContent = (b.textContent || '').trim(); b.textContent = ''; b.appendChild(s);
    });
  }
  function apply(box) {
    var inv; try { inv = JSON.parse(box.getAttribute('data-ng-inv') || '{}'); } catch (e) { return; }
    var root = box.closest('.product, [data-section-type="product"], main') || document;
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    var id = idEl ? String(idEl.value) : '';
    var inStock = inv[id] !== undefined && Number(inv[id]) > 0;
    var inEl = box.querySelector('[data-ng-in]'), preEl = box.querySelector('[data-ng-pre]');
    /* Zero stock with no pre-order plan = sold out: show neither message. */
    var addBtn = form.querySelector('button[name="add"]');
    var soldOut = !inStock && addBtn && (addBtn.disabled || /^sold/i.test((addBtn.textContent || '').trim()));
    if (inEl) inEl.hidden = !inStock;
    if (preEl) preEl.hidden = inStock || soldOut;
    root.querySelectorAll('form[action*="/cart/add"] [name="selling_plan"]').forEach(function (i) { i.disabled = inStock; });
    root.querySelectorAll('form[action*="/cart/add"] button[name="add"]').forEach(function (b) {
      var avail = b.getAttribute('data-lang-available') || 'Add to Cart';
      var t = (b.textContent || '').trim().toLowerCase();
      if (inStock && t.indexOf('pre') === 0) {
        var span = b.querySelector('[data-add-to-cart-text]'); (span || b).textContent = avail; b.value = avail; b.setAttribute('data-ng-swapped', '1');
      }
    });
    root.querySelectorAll('[class*="timesact"]').forEach(function (e) {
      if (inStock) { if (!e.hasAttribute('data-ng-hid')) { e.setAttribute('data-ng-hid', e.style.display || ''); } e.style.display = 'none'; }
      else if (e.hasAttribute('data-ng-hid')) { e.style.display = e.getAttribute('data-ng-hid'); e.removeAttribute('data-ng-hid'); }
    });
    if (!inStock) {
      root.querySelectorAll('button[data-ng-swapped]').forEach(function (b) { b.removeAttribute('data-ng-swapped'); });
    }
  }
  function run() { fixLabels(); document.querySelectorAll('[data-ng-stock]').forEach(apply); }
  document.addEventListener('change', function () { fixLabels(); setTimeout(run, 60); }, true);
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) { var b = m[i].target.closest && m[i].target.closest('button[data-add-to-cart]'); if (b && !b.querySelector('[data-add-to-cart-text]')) { fixLabels(); return; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function () { setTimeout(run, 120); }, true);
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  setInterval(run, 700);
})();
